export default __webpack_public_path__ + "static/analysts_Debater_ENTP_personality_header-f9b20b2a023af767c1dc42539f33a083.svg";